export const categories = [
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-happy-line', color: 'accent', count: 12580 },
  { slug: 'shenghuo', name: '生活', icon: 'ri-home-heart-line', color: 'primary', count: 9840 },
  { slug: 'caiyi', name: '才艺', icon: 'ri-music-line', color: 'secondary', count: 7620 },
  { slug: 'zixun', name: '资讯', icon: 'ri-newspaper-line', color: 'accent', count: 11350 },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line', color: 'primary', count: 8960 },
  { slug: 'lvxing', name: '旅行', icon: 'ri-plane-line', color: 'secondary', count: 6540 },
  { slug: 'keji', name: '科技', icon: 'ri-smartphone-line', color: 'accent', count: 5430 },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', color: 'primary', count: 10230 },
  { slug: 'yinyue', name: '音乐', icon: 'ri-headphone-line', color: 'secondary', count: 7890 },
  { slug: 'yundong', name: '运动', icon: 'ri-run-line', color: 'accent', count: 6120 },
]